import React from "react";
import Dbm from "dbm";

export default class ElfsightReviewWidget extends Dbm.react.BaseObject {
    _construct() {
        super._construct();

        let element = document.querySelector(".elfsight-app-e2c58c63-01e9-4eb1-855d-3a70d728c4b3");
        if(!element) {
            element = document.createElement("div");
            element.className = "elfsight-app-e2c58c63-01e9-4eb1-855d-3a70d728c4b3";
            element.setAttribute("data-elfsight-app-lazy", true);
        }
        this.item.setValue("element", element);

        let scriptLoader = Dbm.loading.loadScript("https://elfsightcdn.com/platform.js");
        //Dbm.flow.runWhenMatched(scriptLoader.item.properties.status, 1, Dbm.commands.callFunction(this._mapStatus.bind(this), [scriptLoader]));
    }

    componentDidMount() {
        //console.log("componentDidMount");
		
        let parentElement = this.item.holderElement;
        parentElement.appendChild(this.item.element);
    }

    componentDidUpdate() {
        //console.log("componentDidUpdate");
        let parentElement = this.item.holderElement;
        parentElement.appendChild(this.item.element);
    }

    _renderMainElement() {

		let returnElement = this._mainElement(<div className="overflow-hidden">
            <div className="centered-site overflow-hidden">
                <div ref={this.createRef("holderElement")} />
            </div>
        </div>);

        return returnElement;
    }
}